import { IrisQueryParamsBuilder } from '@iris/api-query';
import { IrisFilterDefaultChipItemViewComponent } from '@iris/modules/module-filters-v2/chips/default-chip-item-view.component';
import { IrisCompaniesService } from '@iris/common/services/companies.service';
import { IrisCompanyI } from '@iris/common/models/IrisCompany';
import { isObject } from 'lodash';
import { map, shareReplay } from 'rxjs/operators';
import { IrisFilterChipRenderingOptions } from './chip-rendering-options';
import { ComponentRef } from '@angular/core';

type Company = IrisCompanyI | IrisCompanyI['id'];

export const COMPANY_CHIP_RENDERING_OPTIONS: IrisFilterChipRenderingOptions<IrisFilterDefaultChipItemViewComponent, Company> = {
  component: IrisFilterDefaultChipItemViewComponent,
  initComponentFn: (componentRef: ComponentRef<IrisFilterDefaultChipItemViewComponent>, company, injector) => {
    const component = componentRef.instance;
    const service = injector.get(IrisCompaniesService);
    const id = isObject(company) ? company.id : company;
    const params = new IrisQueryParamsBuilder().onlyFields(['name']).toStructure();

    component.text$ = service.getById(id, params)
      .pipe(
        map(entity => entity?.name ?? ''),
        shareReplay({ bufferSize: 1, refCount: true }),
      );
  },
};
